/**
 * Formats the target value based on KPI variable type and polarization
 * @param {Object} item - The KPI item data
 * @returns {string} - Formatted target value
 */
export function getTargetTahunan(item) {
  const numberFormat = new Intl.NumberFormat('id');

  if (item.jenis_variable_kpi_id == 2) {
    return item.target_waktu;
  }
  if (item.jenis_variable_kpi_id == 4) {
    return item.target_manual;
  }
  if (item.jenis_variable_kpi_id == 1) {
    if (item.polarisasi == 'Rentang' || item.polarisasi == 'Rentang 4 Titik') {
      return numberFormat.format(item.target_nominal) + '-' + numberFormat.format(item.target_nominal_max);
    }
    return numberFormat.format(item.target_nominal);
  }
  return '';
}
